import * as React from 'react';
import { DialogTitle } from '@material-ui/core';
import { DialogContent } from '@material-ui/core';
import { DialogActions } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { observer } from 'mobx-react';
import { IObservableObject, IObservableValue, observable } from 'mobx';
import { getEmptyEmployeeRequest, EmployeeRequest } from './userTypes';
import { isValidationErrors, ValidationErrors } from '../../api/restApi';
import { EmployeeForm } from './EmployeeForm';
import { translation } from '../../i18n';
import { Dialog } from '@material-ui/core';
import { isValid } from '../../util/validations';
import { Spinner } from '../../spinner/Spinner';
import { createEmployee } from './userApi';

interface Props {
  onClose: () => void;
  onSave: () => void;
  open: boolean;
}

@observer
export default class NewEmployeesDialog extends React.Component<Props> {

  @observable private employee: EmployeeRequest & IObservableObject = observable(getEmptyEmployeeRequest());
  @observable private validationErrors: ValidationErrors | undefined = undefined;
  private dirtyState: IObservableValue<boolean> = observable.box(false);
  private loading: IObservableValue<boolean> = observable.box(false);

  constructor(props: Props) {
    super(props);
    this.init = this.init.bind(this);
  }

  public render() {
    return (
      <Dialog
        id="newEmployeeDialog"
        open={this.props.open}
        onClose={this.props.onClose}
        fullWidth={true}
        maxWidth="md"
        onRendered={this.init}
      >
        <DialogTitle id="form-dialog-title">{translation.t('newEmployeeDialog.title')}</DialogTitle>
        {
          this.loading.get() ?
            <Spinner/> :
            <>
              <DialogContent>
                <EmployeeForm
                  employee={this.employee}
                  dirtyState={this.dirtyState}
                  fieldErrors={this.validationErrors ? this.validationErrors.fieldErrors : []}
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={this.props.onClose} color="primary">
                  {translation.t('actions.cancel')}
                </Button>
                <Button onClick={() => this.onSaveClicked()} color="primary">
                  {translation.t('actions.save')}
                </Button>
              </DialogActions>
            </>
        }
      </Dialog>)
  }

  private init() {
    this.dirtyState.set(false);
    this.validationErrors = undefined;
    this.employee = observable(getEmptyEmployeeRequest());
  }

  private onSaveClicked() {
    this.validationErrors = isValid(this.employee);
    if (this.validationErrors === undefined || this.validationErrors.fieldErrors.length === 0) {
      this.loading.set(true);
      createEmployee(this.employee).then(
        data => {
          this.loading.set(false);
          if (isValidationErrors(data)) {
            this.validationErrors = data;
          } else {
            this.validationErrors = undefined;
            this.props.onSave()
          }
        }
      );
    }
  }
}
